import { getProjectHrefPrefix } from "./getProjectHrefPrefix"

const getTargetProps = (e: any) => {
    const target = e.target    
    if (!target) {
        return { target: undefined, targetLink: undefined }
    }
    const targetA = (target.tagName === 'A') && target
    const paretnA = (target.parentElement.tagName === 'A') && target.parentElement
    const grandParetnA = (target.parentElement.parentElement.tagName === 'A') &&
        target.parentElement.parentElement
    const grandGrandParetnA = (target.parentElement.parentElement.parentElement.tagName === 'A') && 
        target.parentElement.parentElement.parentElement
    const targetLink = targetA?.href || paretnA?.href || grandParetnA?.href || grandGrandParetnA?.href
    return { target, targetLink }    
  }


export const navigationHandler = (e: any, navigationProps: any) => {
    const { project } = navigationProps || {}
    const { target, targetLink } = getTargetProps(e)
  
    if (!(project?.projectId || navigationProps?.projectId)) return
    const isProjectLink = targetLink?.includes('/project/')
    const isDesignerLink = navigationProps?.projectId
   
    const url = isDesignerLink
        ? navigationProps?.author?.accountId && `${getProjectHrefPrefix(navigationProps)}/designer/${navigationProps?.author?.accountId}`
        : targetLink
    window.open(url, '_blank')
  }
  import { getProjectHrefPrefix } from "./getProjectHrefPrefix"

const getTargetProps = (e: any) => {
    const target = e.target    
    if (!target) {
        return { target: undefined, targetLink: undefined }
    }
    const targetA = (target.tagName === 'A') && target
    const paretnA = (target.parentElement.tagName === 'A') && target.parentElement
    const grandParetnA = (target.parentElement.parentElement.tagName === 'A') &&
        target.parentElement.parentElement
    const grandGrandParetnA = (target.parentElement.parentElement.parentElement.tagName === 'A') && 
        target.parentElement.parentElement.parentElement
    const targetLink = targetA?.href || paretnA?.href || grandParetnA?.href || grandGrandParetnA?.href
    return { target, targetLink }    
  }


export const navigationHandler = (e: any, navigationProps: any) => {
    const { project } = navigationProps || {}
    const { target, targetLink } = getTargetProps(e)
  
    if (!(project?.projectId || navigationProps?.projectId)) return
    const isProjectLink = targetLink?.includes('/project/')
    const isDesignerLink = navigationProps?.projectId
   
    const url = isDesignerLink
        ? navigationProps?.author?.accountId && `${getProjectHrefPrefix(navigationProps)}/designer/${navigationProps?.author?.accountId}`
        : targetLink
    window.open(url, '_blank')
  }
  